// extracted by mini-css-extract-plugin
module.exports = {"error_container":"SelectEmailFlowPopup_error_container__3uYGz","error_text":"SelectEmailFlowPopup_error_text__z1iUB"};